import './App.css';
import { Amplify } from 'aws-amplify';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import AppRouter from './router';
import outputs from '../src/amplify_outputs.json';
import Sidebar from './components/Sidebar/Sidebar';
import UploadFile from './layouts/Main/UploadFile/UploadFile';
import { useAuth } from './utils/context/useAuthContext';
import ReactLoading from 'react-loading';

Amplify.configure(outputs);

function App() {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          backgroundColor: '#E7ECF2',
        }}
      >
        <ReactLoading
          type={'bubbles'}
          color={theme.palette.green.main}
          height={250}
          width={250}
        />
      </Box>
    );
  }

  const renderDesktopAuthLayout = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        background: 'linear-gradient(to right, #C1FE40 30%, #2C2C2C 30%)',
        position: 'relative',
      }}
    >
      <Box
        component="img"
        src="/assets/background/CoinsAuth.svg"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '23%',
          width: '50%',
          height: '90%',
          transform: 'translate(-50%, -50%)',
          zIndex: 10,
          pointerEvents: 'none',
          '@media (max-width: 600px)': {
            width: '80%',
            left: '50%',
          },
          '@media (min-width: 1200px)': {
            width: '40%',
          },
        }}
      />
      <Box
        sx={{
          width: {
            xs: '100%',
            sm: '100%',
            md: '1200px',
            lg: '1200px',
            xl: '1440px',
          },
          px: {
            xs: '20px',
            sm: '20px',
            md: '0px',
            lg: '0px',
            xl: '0px',
          },
          background: 'transparent',
          display: 'flex',
          position: 'relative',
          zIndex: 11,
        }}
      >
        <AppRouter />
      </Box>
    </Box>
  );

  const renderMobileAuthLayout = () => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flexGrow: 1,
        alignItems: 'center',
        position: 'relative',
        backgroundColor: '#2C2C2C',
        overflow: 'hidden',
      }}
    >
      <Box
        component="img"
        src="/assets/background/CoinsAuth.svg"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '20%',
          width: '80%',
          height: '90%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1,
          pointerEvents: 'none',
          opacity: 0.4,
        }}
      />
      <Box
        sx={{
          width: '100%',
          px: '20px',
          background: 'transparent',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
          zIndex: 2,
        }}
      >
        <AppRouter />
      </Box>
    </Box>
  );

  const renderMainAppLayout = () => (
    <Box
      sx={{
        width: {
          xs: '100%',
          sm: '100%',
          md: '80%',
          lg: '80%',
          xl: '80%',
        },
        pt: '44px',
        pb: '20px',
        px: {
          xs: '20px',
          sm: '20px',
          md: '0px',
          lg: '0px',
          xl: '0px',
        },
        pr: {
          md: '140px',
          xl: '0px',
          lg: '135px',
        },
      }}
    >
      <Sidebar />

      <AppRouter />
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh',
        backgroundColor: '#E7ECF2',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {isAuthenticated
        ? renderMainAppLayout()
        : isMobile
          ? renderMobileAuthLayout()
          : renderDesktopAuthLayout()}
      <UploadFile />
    </Box>
  );
}

export default App;
